import { useTrial } from '~features/FreeTrial/useTrial';
import { useIsSubscriptionCancelled } from './usePrerenderUser';

/**
 * Account-level billing predicate: true when the account is on a free trial
 * that has expired (never converted to a paid subscription) or the paid
 * subscription has been cancelled. Paying accounts are never expired, even
 * when a past trial date is still present on the user. Derived synchronously
 * from user state, so it is reliable before any feature-specific data query
 * resolves.
 */
export function useIsAccountExpired(): boolean {
  const { isInTrial, daysLeftOnTrial } = useTrial();
  const isSubscriptionCancelled = useIsSubscriptionCancelled();

  const isTrialExpired = isInTrial && daysLeftOnTrial === 0;

  return isTrialExpired || isSubscriptionCancelled;
}
